/**
 * Tells whether a reloaded upload operation is taken back by this tab (reattached) instead of being claimed and
 * re-run: it has uploaded files and its latest row is not 'error'. A job without files is dead (its files lived only in the
 * browser), and an error job keeps the claim and replace path (DE-1816, ADR-0039, amending ADR-0010).
 *
 * @param {object} operation - The operation, with its files and worker messages.
 * @returns {boolean} true if the operation is reattached.
 */
export const isReattachable = (operation) => {
    const latest = operation?.workerMessages?.at(-1);
    return _hasFiles(operation) && !!latest && latest.status !== 'error';
};

const _hasFiles = (operation) => Array.isArray(operation?.files) && operation.files.length > 0;
